export default "__VITE_ASSET__e59fcc67__"